const moduleOrder = [
  'dashboard',
  'operational-unit',
  'high-risk',
  'data-input',
  'single-number',
  'setup-single-number',
  'user-role',
  'private-qhse'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js